//This class came with the UI template we purchased. It had a bunch of junk we didn't need, so Gilmer tried to purge it a bit.
//this is the template of the page once the user has logged in: header and main menu. The space on the right will be filled in with sub-pages.
import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { MessageBoxComponent } from '../../shared/message-box/message-box.component';
import { WebService } from '../../shared/web-service/web.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  animations: [
    trigger('notificationBottom', [
      state('an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('an-animate',
        style({
          overflow: 'hidden',
          height: AUTO_STYLE,
        })
      ),
      transition('an-off <=> an-animate', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('mobileHeaderNavRight', [
      state('nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('nav-on',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('nav-off <=> nav-on', [
        animate('400ms ease-in-out')
      ])
    ]),
  ]
})
export class AdminComponent implements OnInit {
  @ViewChild('modalChangePwd') modalChangePwd;
  @ViewChild('modalHelpAbout') modalHelpAbout;
  @ViewChild('msgBox') msgBox;
  @ViewChild('appTitle') appTitle;

  static staticInstance: AdminComponent;

  public navType: string;
  public themeLayout: string;
  public verticalPlacement: string;
  public verticalLayout: string;
  public pcodedDeviceType: string;
  public verticalNavType: string;
  public verticalEffect: string;
  public vnavigationView: string;
  public freamType: string;
  public sidebarImg: string;
  public sidebarImgType: string;
  public layoutType: string;

  public headerTheme: string;
  public pcodedHeaderPosition: string;

  public liveNotification: string;
  public liveNotificationClass: string;

  public profileNotification: string;
  public profileNotificationClass: string;

  public navRight: string;
  public windowWidth: number;

  public toggleOn: boolean;
  public navBarTheme: string;
  public activeItemTheme: string;
  public pcodedSidebarPosition: string;

  public menuTitleTheme: string;
  public dropDownIcon: string;
  public subItemIcon: string;

  public headerFixedMargin: string;
  public sidebarFixedHeight: string;
  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public itemBorder: boolean;
  public employeeName: string;

  public config: any;

  passwordOld: string;
  passwordNew: string;
  passwordConfirm: string;
  passwordErrorMsg: string;
  showPasswordErrorMsg: boolean = false;

  constructor(public menuItems: MenuItems, private webService: WebService) {
    AdminComponent.staticInstance = this;

    this.employeeName = sessionStorage.employeeName;
    if (!this.employeeName || this.employeeName.length === 0 || !sessionStorage.validationToken || sessionStorage.validationToken.length === 0)
      this.onLogout();

    this.navType = 'st2';
    this.themeLayout = 'vertical';
    this.verticalPlacement = 'left';
    this.verticalLayout = 'wide';
    this.pcodedDeviceType = 'desktop';
    this.verticalNavType = 'expanded';
    this.verticalEffect = 'shrink';
    this.vnavigationView = 'view1';
    this.freamType = 'theme1';
    this.sidebarImg = 'false';
    this.sidebarImgType = 'img1';
    this.layoutType = 'light';

    this.pcodedHeaderPosition = 'fixed';

    this.liveNotification = 'an-off';
    this.profileNotification = 'an-off';

    this.navRight = 'nav-on';

    this.windowWidth = window.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    this.toggleOn = true;
    this.navBarTheme = 'theme1';
    //this.activeItemTheme = 'theme10'; 
    this.pcodedSidebarPosition = 'fixed';
    this.menuTitleTheme = 'theme6';
    //this.dropDownIcon = 'style3';
    this.subItemIcon = 'style7';

    this.headerFixedMargin = '56px';
    this.sidebarFixedHeight = 'calc(100vh - 56px)';
    this.itemBorderStyle = 'none';
    this.subItemBorder = true;
    this.itemBorder = true;

    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);

    // dark
    /*this.setLayoutType('dark');*/

    // light-dark
    /*this.setLayoutType('dark');
    this.setNavBarTheme('themelight1');*/

    // dark-light
    /*this.setNavBarTheme('theme1');*/

    // side-bar image
    /*this.setLayoutType('img');*/
    //???These are ones customized by Gilmer
    this.setLayoutType('img');
    this.headerTheme = 'theme1';
    this.dropDownIcon = 'style1';
    this.activeItemTheme = 'theme5'//this is for the color of the selected menu item.
  }

  ngOnInit() {
    this.setBackgroundPattern('pattern1');
    // The msgBox of this component can be used anywhere. Use setTimeout to make sure the object has been created.
    setTimeout(() => {
      MessageBoxComponent.staticInstance = this.msgBox;
    }, 100);
    /*document.querySelector('body').classList.remove('dark');*/
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.navRight = 'nav-off';
    } else {
      this.navRight = 'nav-on';
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.pcodedDeviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleHeaderNavRight() {
    this.navRight = this.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
  }

  toggleLiveNotification() {
    this.liveNotification = this.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.liveNotificationClass = this.liveNotification === 'an-animate' ? 'active' : '';
  }

  toggleProfileNotification() {
    this.profileNotification = this.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.profileNotificationClass = this.profileNotification === 'an-animate' ? 'active' : '';
  }

  notificationOutsideClick(ele: string) {
    if (ele === 'live' && this.liveNotification === 'an-animate') {
      this.toggleLiveNotification();
    } else if (ele === 'profile' && this.profileNotification === 'an-animate') {
      this.toggleProfileNotification();
    }
  }

  toggleOpened() {
    if (this.windowWidth < 992) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      if (this.navRight === 'nav-on') {
        this.toggleHeaderNavRight();
      }
    }
    this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
  }

  onClickedOutsideSidebar(e: Event) {
    if ((this.windowWidth < 992 && this.toggleOn && this.verticalNavType !== 'offcanvas') || this.verticalEffect === 'overlay') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  setNavBarTheme(theme: string) {
    if (theme === 'themelight1') {
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      this.sidebarImg = 'false';
    } else {
      this.menuTitleTheme = 'theme6';
      this.navBarTheme = 'theme1';
      this.sidebarImg = 'false';
    }
  }

  setLayoutType(type: string) {
    this.layoutType = type;
    if (type === 'dark') {
      this.headerTheme = 'theme1';
      this.sidebarImg = 'false';
      this.navBarTheme = 'theme1';
      this.menuTitleTheme = 'theme6';
      document.querySelector('body').classList.add('dark');
    } else if (type === 'light') {
      this.sidebarImg = 'false';
      this.headerTheme = 'themelight5';
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      document.querySelector('body').classList.remove('dark');
    } else if (type === 'img') {
      this.sidebarImg = 'true';
      this.headerTheme = 'theme1';
      this.navBarTheme = 'theme1';
      this.menuTitleTheme = 'theme6';
      document.querySelector('body').classList.remove('dark');
    }
  }

  setBackgroundPattern(pattern: string) {
    document.querySelector('body').setAttribute('themebg-pattern', pattern);
  }

  onShowAbout() {
    this.modalHelpAbout.show();
    setTimeout(function () { $("#aboutModalOkButton").focus() }, 300); //set focus on button so if user clicks Enter, it will close. We have to use setTimeout to set the focus because you can't set focus until it appears, which takes a moment.
  }

  onChangePwd() {
    this.passwordOld = "";
    this.passwordNew = "";
    this.passwordConfirm = "";
    this.showPasswordErrorMsg = false;
    this.modalChangePwd.show();
    setTimeout(function () { $("#passwordOld").focus() }, 300); //set focus on first field
  }

  finishChangePwd() {
    if (this.passwordOld.length === 0 || this.passwordNew.length === 0 || this.passwordConfirm.length === 0) {
      this.passwordErrorMsg = "Please enter your old password, new password, and confirmation password.";
      this.showPasswordErrorMsg = true;
      return;
    }
    if (this.passwordNew !== this.passwordConfirm) {
      this.passwordErrorMsg = "The new password does not match the confirmation password.";
      this.showPasswordErrorMsg = true;
      return;
    }

    this.showPasswordErrorMsg = false;

    this.webService.authentication_ChangePassword(sessionStorage.userName, this.passwordOld, this.passwordNew, localStorage.agency).subscribe(
      apiResponse => {
        if (apiResponse.errorCode === 0) {
          //change pwd worked
          this.modalChangePwd.hide();
          this.msgBox.show("Success", "Your password has been changed.", false);
        }
        else {
          //server says something didn't work, so show message from server.
          this.passwordErrorMsg = apiResponse.errorMessage;
          this.showPasswordErrorMsg = true;
        }
      }
    );
  }

  onLogout() {
    sessionStorage.clear();
    //we can't just do window.location.pathname = "login" because it's possible our URL has a virtual folder we need to worry about.
    window.location.assign(document.getElementsByTagName('base')[0].href + "login");
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }
}
